


import {defineComponent, ref, SetupContext} from 'vue';
import Hero from "@/components/common/typography/Hero.vue";
import Caption from "@/components/common/typography/Caption.vue";
import Icon from "@/components/common/icons/Icon.vue";

export interface NotificationData {
  title: string,
  text?: string
}

export default defineComponent({
  name: 'Notification',
  components: {Caption, Hero, Icon},
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
    }
  },
  setup(props, context) {
    const isClosed = ref(false);
    return () =>
      <div class={[
        "notification",
        isClosed.value ? "notification--closed" : "",
      ]}>
        <Icon class="notification-check" name="Check"/>
        <div class="notification-content">
          <Hero class="notification-content-title" type="Hero6" withFocusLine={false}>{props.title}</Hero>
          {props.text &&
          <Caption class="notification-content-text">{props.text}</Caption>
          }
        </div>
        <Icon class="notification-close" name="Close" onClick={() => {
          isClosed.value = true
        }}/>

      </div>
  }
});

